var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIconCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.43235 5.30098C6.11994 4.98856 5.6134 4.98856 5.30098 5.30098C4.98856 5.6134 4.98856 6.11993 5.30098 6.43235L6.86863 8L5.30098 9.56764C4.98856 9.88006 4.98856 10.3866 5.30098 10.699C5.6134 11.0114 6.11994 11.0114 6.43235 10.699L8 9.13137L9.56765 10.699C9.88007 11.0114 10.3866 11.0114 10.699 10.699C11.0114 10.3866 11.0114 9.88006 10.699 9.56764L9.13137 8L10.699 6.43235C11.0114 6.11993 11.0114 5.6134 10.699 5.30098C10.3866 4.98856 9.88007 4.98856 9.56765 5.30098L8 6.86863L6.43235 5.30098Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconCircle);
export default __webpack_public_path__ + "static/media/cross-icon-circle.ec7f873303d63b8e51507d0641e15ea0.svg";
export { ForwardRef as ReactComponent };